import { IconName } from "../Components/Icon/Icon";
import { Order } from "../Generated/graphql";

export type ShipmentStatus =
  | "pending"
  | "acknowledged"
  | "picked"
  | "packed"
  | "in_transit"
  | "invoiced"
  | "cancelled"
  | "backorder";

export type ShipmentStatusInfo = {
  status: ShipmentStatus;
  label: string;
  icon: IconName;
  trackingUrl: string | null;
};

/**
 * Determines the lifecycle/shipment status of an order based on its flags
 * and shipment data from the order service.
 */
export function getShipmentStatus(order: Order): ShipmentStatusInfo {
  if (order.cancelled) {
    return { status: "cancelled", label: "Annulleret", icon: "close", trackingUrl: null };
  }

  if (order.backorder) {
    return { status: "backorder", label: "Restordre", icon: "orderTruck", trackingUrl: null };
  }

  if (order.invoiced) {
    return { status: "invoiced", label: "Faktureret", icon: "checkmarkGreen", trackingUrl: null };
  }

  // In transit — has tracking URL, or shipping agent + shipment number
  if (order.trackAndTraceUrl || (order.shippingAgent && order.shipmentNo)) {
    const trackingUrl = order.trackAndTraceUrl || null;
    const label = trackingUrl ? "Undervejs — sporing tilgængelig" : "Undervejs";
    return { status: "in_transit", label, icon: "orderTruckGreen", trackingUrl };
  }

  if (order.packed) {
    return { status: "packed", label: "Pakket — klar til afsendelse", icon: "orderTruckGreen", trackingUrl: null };
  }

  if (order.picked) {
    return { status: "picked", label: "Plukket", icon: "orderTruck", trackingUrl: null };
  }

  if (order.acknowledged) {
    return { status: "acknowledged", label: "Ordren behandles", icon: "orderTruck", trackingUrl: null };
  }

  return { status: "pending", label: "Afventer behandling", icon: "cartListview", trackingUrl: null };
}
